import { InternalDatabaseService } from '@stockcare-storage/internal/internal-database.service';
import { Injectable } from '@angular/core';
import { Service } from './service';
import { IService } from '@stockcare-models/IService';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { Settings } from '@stockcare-helpers/settings';

@Injectable({
  providedIn: 'root',
})
export class ServicesStorageService {
  readonly table: string;
  readonly index: string;
  enableLocalDB: boolean;
  services: Service[] = [];

  constructor(
    private internalDatabaseService: InternalDatabaseService,
    private readonly settingsService: SettingsService,
    private readonly deviceService: DeviceService
  ) {
    const table = Service.getTableDefinition();
    this.table = table.TableName;
    this.index = table.Indexes[0].Name;
    this.getSettings();
  }

  async addServices(services: Service[]) {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.addRange<Service>(this.table, services);
    } else {
      this.services = [...services];
    }
  }

  async getServices(): Promise<Service[]> {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getAll<Service>(this.table);
    } else {
      return [...this.services];
    }
  }

  async getServiceByIndex(barcode) {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getByIndex<Service>(this.table, this.index, barcode);
    } else {
      return this.services.find((stock) => stock.Barcode === barcode);
    }
  }

  async updateService(service: Service): Promise<void> {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.update(this.table, service);
    } else {
      return new Promise<void>((resolve) => {
        this.services = this.services.filter((stock) => stock.ServiceId !== stock.ServiceId);

        this.services.push(service);
        resolve();
      });
    }
  }

  async deleteAll() {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.deleteAll(this.table);
    } else {
      this.services = [];
    }
  }

  map(services: IService[]) {
    const savedServices: Service[] = [];

    for (const service of services) {
      const mappedService = new Service();
      mappedService.Id = service.id;
      mappedService.ServiceId = service.serviceId;
      mappedService.Barcode = service.barcode;
      mappedService.UnitOfMeasure = service.unitOfMeasure;
      mappedService.Quantity = service.quantity;
      mappedService.Name = service.name;
      savedServices.push(mappedService);
    }

    return savedServices;
  }

  getSettings() {
    const theatreDevice = this.deviceService.isTheaterDevice();
    if (theatreDevice) {
      this.enableLocalDB = this.settingsService.getBooleanSetting(Settings.ENABLE_INDEXED_DB);
    } else {
      this.enableLocalDB = true;
    }
  }
}
